import Vue from 'vue';
import date from './date';
import timestamp from './timestamp';
import space2nbsp from './space2nbsp';
import formatedNumber from './formatedNumber';

Vue.filter('date', date);
Vue.filter('timestamp', timestamp);
Vue.filter('space2nbsp', space2nbsp);
Vue.filter('formatedNumber', formatedNumber);